import FontFaceObserver from 'fontfaceobserver';

/**
 * Fit the text to its container by setting the SVG viewbox size after the font has loaded
 */

class FitSVGText {
  constructor() {
    this.elements = Array.from(document.querySelectorAll('svg.js-fit-text'));
    this.fontObserver = new FontFaceObserver('PP Eiko');

    // Re-fit text whenever body size has changed
    this.resizeObserver = new ResizeObserver(() => {
      this.elements.forEach(svg => {
        const bbox = svg.querySelector('text').getBBox();
        this.fit(svg, bbox);
      });
    });

    // Wait until font has loaded before initial fit
    this.fontObserver.load().then(() => {
      this.resizeObserver.observe(document.body);
    });
  }

  /**
   * Fit SVG text within its container.
   */
  fit(svg, bbox) {
    svg.setAttribute(
      'viewBox',
      [Math.round(bbox.x), Math.round(bbox.y), bbox.width, bbox.height].join(' '),
    );
  }
}

export default FitSVGText;
